import {
  BoltIcon,
  ChartBarIcon,
  CurrencyDollarIcon,
  HomeIcon,
  LinkIcon,
  TrophyIcon,
} from "@heroicons/react/24/outline";
import { Link, useLocation } from "react-router-dom";

const menu = [
  { name: "Dashboard", icon: HomeIcon, path: "/" },
  { name: "Statistics", icon: ChartBarIcon, path: "/statistics" },
  { name: "Links", icon: LinkIcon, path: "/links" },
  { name: "Withdraw", icon: CurrencyDollarIcon, path: "/withdraw" },
  { name: "Leaderboard", icon: TrophyIcon, path: "/top10-partners" },
];

export default function Sidebar() {
  const location = useLocation();

  return (
    <aside className="hidden md:flex fixed inset-y-0 left-0 z-30 w-[280px] flex-col border-r border-white/10 bg-[rgba(7,12,21,0.82)] px-5 py-6 backdrop-blur-xl">
      <div className="rounded-3xl border border-white/10 bg-white/5 p-5 shadow-[0_30px_80px_rgba(0,0,0,0.28)]">
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[linear-gradient(135deg,#1dd9af,#ffb84d)] text-[18px] font-black text-slate-950">
            IQ
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.28em] text-[var(--aff-muted)]">
              Partner desk
            </div>
            <div className="text-xl font-black text-white">IQ CAGE Affiliate</div>
          </div>
        </div>
        <div className="mt-4 rounded-2xl border border-emerald-400/20 bg-emerald-400/10 px-4 py-3 text-sm text-emerald-100">
          Turn referral traffic into tracked registrations, turnover, and withdrawable commission.
        </div>
      </div>

      <nav className="mt-6 flex-1 space-y-2">
        {menu.map(({ name, icon: Icon, path }) => {
          const active = location.pathname === path;
          return (
            <Link
              key={name}
              to={path}
              className={`group flex items-center gap-3 rounded-2xl border px-4 py-3 transition ${
                active
                  ? "border-emerald-400/40 bg-emerald-400/12 text-white shadow-[0_12px_40px_rgba(29,217,175,0.16)]"
                  : "border-white/6 bg-white/[0.03] text-slate-300 hover:border-white/12 hover:bg-white/[0.06]"
              }`}
            >
              <Icon className={`h-5 w-5 ${active ? "text-emerald-300" : "text-slate-400 group-hover:text-white"}`} />
              <span className="font-medium">{name}</span>
            </Link>
          );
        })}
      </nav>

      <div className="rounded-3xl border border-white/10 bg-white/[0.04] p-4">
        <div className="flex items-center gap-2 text-sm font-semibold text-white">
          <BoltIcon className="h-5 w-5 text-amber-300" />
          Pro tips
        </div>
        <p className="mt-2 text-sm leading-6 text-[var(--aff-muted)]">
          Create separate links for each channel so you can see which traffic source drives the best turnover.
        </p>
      </div>
    </aside>
  );
}
